<template>
  <div class="justify-content-center text-left mt-5 dp02 p-5">
    <div class="col-lg-12">
      <b-button type="submit"
                class="myButton"
                @click="$router.go(-1)"
                style="float:left">
        {{ $t('common.Back') }}
      </b-button>
    </div>
    <div
      class="row col-lg-12 mt-5">
      <div class="col-12">
        <h2>{{ $t('entities.ConsultingRoom.Singular') }} {{ consultingRoomName }}</h2>
      </div>
      <ValidationObserver ref="observer"
                          class="row col-12"
                          v-slot="{invalid}"
                          tag="form"
                          @submit.prevent="submit()">
        <div class="col-4">
          <div class="row my-3">
            <div class="col-lg-3">
              <label for="gender">{{ $t('fields.name') }}:</label>
            </div>
            <div class="col-lg-9">
              <ValidationProvider
                name="name"
                rules="required"
                v-slot="{errors, classes}">
                <b-form-input
                  :class="{...classes, myInput: true}"
                  v-model="name" />
                <p class="myInputError">
                  {{ errors[0] }}
                </p>
              </ValidationProvider>
            </div>
          </div>
          <div class="row my-3">
            <div class="col-lg-3">
              <label for="gender">{{ $t('fields.enabled') }}:</label>
            </div>
            <div class="col-lg-9">
              <b-form-checkbox
                :value="true"
                :unchecked-value="false"
                v-model="enabled" />
            </div>
          </div>
          <div class="row my-3">
            <div class="col-lg-3">
              <label for="gender">{{ $t('fields.doctor') }}:</label>
            </div>
            <div class="col-lg-9">
              <ValidationProvider
                name="doctor"
                ref="doctor"
                rules="required"
                v-slot="{errors, classes}">
                <DoctorInput v-model="doctor" />
                <p class="myInputError">
                  {{ errors[0] }}
                </p>
              </ValidationProvider>
            </div>
          </div>
        </div>
        <div class="row col-4 offset-7">
          <b-button
            type="submit"
            class="myButton align-middle">
            {{ $t("common.Edit") }}
          </b-button>
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>
<script>
import { mapActions, mapMutations } from 'vuex';
import DoctorInput from '@components/input/DoctorInput';

export default {
  name: 'ConsultingRoomEdit',
  components: {
    DoctorInput
  },
  data() {
    return {
      consultingRoomName: ''
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    name: {
      get() {
        return this.$store.state.editConsultingRoom.name;
      },
      set(val) {
        this.setName(val);
      }
    },
    enabled: {
      get() {
        return this.$store.state.editConsultingRoom.enabled;
      },
      set(val) {
        this.setEnabled(val);
      }
    },
    doctor: {
      get() {
        return this.$store.state.editConsultingRoom.doctor;
      },
      set(val) {
        this.setDoctor(val);
      }
    }
  },
  methods: {
    ...mapActions({
      resetContext: 'editConsultingRoom/resetContext',
      editConsultingRoom: 'editConsultingRoom/editConsultingRoom',
      fetchConsultingRoom: 'editConsultingRoom/fetchConsultingRoom'
    }),
    ...mapMutations({ setName: 'editConsultingRoom/setName',
      setEnabled: 'editConsultingRoom/setEnabled',
      setConsultingRoomId: 'editConsultingRoom/setConsultingRoomId',
      setDoctor: 'editConsultingRoom/setDoctor' }),
    async submit() {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.editConsultingRoom()
          .then(() => {
            this.resetContext();
            this.$root.$bvToast.toast(this.$t('EditConsultingRoom.SuccessToast.Body'), {
              title: this.$t('EditConsultingRoom.SuccessToast.Title'),
              variant: 'success',
              toaster: 'b-toaster-top-right'
            });
            this.$router.replace({ name: 'admin.reservations.consultingrooms.view' });
          })
          .catch(() => {
            this.$root.$bvToast.toast(this.$t('EditConsultingRoom.FailToast.Body'), {
              title: this.$t('EditConsultingRoom.FailToast.Title'),
              variant: 'danger',
              toaster: 'b-toaster-top-right'
            });
          });
      }
    }
  },
  created() {
    this.setConsultingRoomId(this.id);
    this.fetchConsultingRoom()
      .then(() => {
        this.consultingRoomName = this.name;
      });
  }
};
</script>
<style lang="scss" scoped>
</style>
